module.exports = __webpack_public_path__ + "static-v-shop/1786392158156/img/cybermonday-productos-mobile.8690bd3b.png";